/**
 * Типы для домашних заданий (admin)
 */

export interface HomeworkFile {
  url: string;
  name: string;
  size: number;
}

export interface HomeworkChecklistItem {
  text: string;
  isCompleted: boolean;
}

export interface HomeworkNoteItem {
  id: string;
  text: string;
  createdAt: string;
}

export interface HomeworkModuleItem {
  id: number;
  type: string;
  title: string;
  description: string | null;
  module: {
    id: number;
    title: string;
    course: {
      id: number;
      slug: string;
      title: string;
    };
  };
}

export interface HomeworkUser {
  id: number;
  firstName: string | null;
  lastName: string | null;
  telegramUsername: string | null;
}

export type HomeworkStatus = 'NOT_STARTED' | 'SUBMITTED' | 'REVIEWED';

export interface HomeworkRecord {
  id: number;
  userId: number;
  itemId: number;
  status: HomeworkStatus;
  files: HomeworkFile[] | null;
  checklistItems: HomeworkChecklistItem[] | null;
  notes: string | null;
  noteItems: HomeworkNoteItem[] | null;
  grade: number | null;
  feedback: string | null;
  submittedAt: string | null;
  startedAt: string | null;
  createdAt: string;
  updatedAt: string;
  item: HomeworkModuleItem;
  user: HomeworkUser;
}

export const HOMEWORK_STATUS_LABELS: Readonly<Record<HomeworkStatus, string>> = {
  NOT_STARTED: 'Не начато',
  SUBMITTED: 'Отправлено',
  REVIEWED: 'Проверено',
};

export const HOMEWORK_STATUS_VARIANTS: Readonly<Record<HomeworkStatus, 'secondary' | 'outline' | 'default'>> = {
  NOT_STARTED: 'secondary',
  SUBMITTED: 'outline',
  REVIEWED: 'default',
};

export function getUserDisplayName(user: HomeworkUser): string {
  const parts = [user.firstName, user.lastName].filter(Boolean);
  if (parts.length > 0) {
    return parts.join(' ');
  }
  return user.telegramUsername ? `@${user.telegramUsername}` : `User #${user.id}`;
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) { return `${bytes} B`; }
  if (bytes < 1024 * 1024) { return `${(bytes / 1024).toFixed(1)} KB`; }
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
